import { render } from "./PayeeList.vue?vue&type=template&id=04953dca"
import script from "./PayeeList.vue?vue&type=script&lang=js"
export * from "./PayeeList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__